// extracted by mini-css-extract-plugin
export default {"header":"GDPRText_header__zGi-b","block":"GDPRText_block__fnld5"};